import {
    allocateInvoicePaymentToItems,
    invoiceItemNetOpenAmounts,
} from "@common/helpers/invoice-line-allocation";
import { sumMonetaryValues } from "@common/helpers/monetary";
import { LineItemAllocation } from "@common/schemas/domains/accrualReview/accrual-review.schema";
import { InvoiceLineItemKind } from "@common/types/invoice";

export interface InvoicePaymentLine {
    id: string;
    amount: number;
    matchedAmount: number;
    kind: InvoiceLineItemKind;
    rowId: string | null;
}

function hasAdjustmentRows(lines: InvoicePaymentLine[]): boolean {
    return lines.some(
        (line) =>
            line.rowId != null ||
            (line.kind === InvoiceLineItemKind.TAX && line.rowId == null),
    );
}

export function getInvoicePaymentOpenAmount({
    lines,
    openAmount,
}: {
    lines: InvoicePaymentLine[];
    openAmount: number;
}): number {
    if (openAmount <= 0 || !hasAdjustmentRows(lines)) {
        return openAmount;
    }

    return sumMonetaryValues(
        invoiceItemNetOpenAmounts(lines).map((item) =>
            Math.max(0, item.openAmount),
        ),
    );
}

export function buildInvoicePaymentAllocations({
    lines,
    paymentAmount,
}: {
    lines: InvoicePaymentLine[];
    paymentAmount: number;
}): LineItemAllocation[] | null {
    if (!hasAdjustmentRows(lines)) {
        return null;
    }

    const allocations = allocateInvoicePaymentToItems({ lines, paymentAmount });

    return allocations.length > 0 ? allocations : null;
}
